import axiosInstance from "@/axios/axiosInstance";
import {
  GetNotificationsRequest,
  GetNotificationsResponse,
} from "@/interface/notification.types";

/**
 * Service for notification related API calls
 */
export const getNotifications = async (
  request?: Partial<GetNotificationsRequest>
): Promise<GetNotificationsResponse> => {
  try {
    const defaultBody: GetNotificationsRequest = {
      pageNumber: 0,
      pageSize: 0,
      query: "",
      filters: "",
      sorts: "",
    };

    const response = await axiosInstance.post<GetNotificationsResponse>(
      "/Notification/Notification",
      { ...defaultBody, ...request }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch notifications:", error);
    throw error;
  }
};
